module.exports = __webpack_public_path__ + "jizvy_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/jizvy_1_after.jpg
// module id = 949
// module chunks = 0